<template>
    <div class="main-container content-center">
        <acca-vue-notification v-if="isPanelSuggestionSent" message="Öneriniz bize ulaştı, teşekkür ederiz!"></acca-vue-notification>
        <h2 class="form-title">Panel - Öneri Gönder</h2>



        <form class="dashboard-form" @submit.prevent="sendPanelSuggestion()" >

            <label class="single-line-label" for="user">Oluşturan</label>
            <input required type="text" readonly id="user" class="dashboard-form__input bg-gray-200" v-model="panelSuggestion.user">

            <label class="single-line-label" for="title">Öneri Başlığı</label>
            <input required type="text" id="title" class="dashboard-form__input" v-model="panelSuggestion.title">

            <label class="single-line-label" for="body">Öneriniz</label>
            <textarea required id="body" rows="5" class="medium-message mb-10" v-model="panelSuggestion.body"> </textarea>

            <div class="button-row">
                <button type="submit" @click="postData(panelSuggestion, 'suggestions', 'panel', 'panelSuggestions')" class="dashboard-form__submit">Oluştur</button>
                <button type="button" @click="goBack" class="dashboard-form__button-secondary button__cancel">İptal</button>
            </div>

        </form>

        <p class="col-start-3 col-end-11 mb-5 text-3xl text-gray-100 leading-snug">Bu bölümden, panel hakkında önerilerinizi gönderebilir; burada görmek istediğiniz özellikleri ve işe yarayacağını düşündüğünüz geliştirmeleri aktarabilirsiniz. 
            Panel ile ilgili yaşadığınız bir sorunu aktarmak veya bir hata bildirmek için, lütfen <router-link class="text-blue-400 hover:text-blue-500" to="bug-report">Hata Bildir</router-link> sayfasını kullanın. 
        </p>

    </div>
</template>

<script>
import postData from "../../mixins/firebaseOperations"
import accaVueNotification from "../reusable/accaVueNotification.vue"
import { mapGetters } from "vuex"

export default {
  name: 'PanelSuggestions',
  data() {
      return {
          isPanelSuggestionSent: false,
          panelSuggestion: {
              user: "",
              title: "",
              body: "",
              created: new Date()
          }
      }
  },

  methods: {
      goBack(){
          this.$router.push("/suggestions")
      },

      sendPanelSuggestion() {
          this.isPanelSuggestionSent = true
          setTimeout(() => {
              this.isPanelSuggestionSent = false
              this.goBack()
          }, 2500)
      }
  },

   computed: {
        ...mapGetters("user", {
            userProfile: "userProfile",
        })
    },

    components: {
      accaVueNotification: accaVueNotification,
  },

  mixins: [postData],

    created(){
      this.panelSuggestion.user = this.userProfile.name
  },

    beforeUpdate(){
        this.panelSuggestion.user = this.userProfile.name
    }
} 

</script>

<style lang="scss">

</style>
